import * as React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

export const QuestCardSkeleton = () => {
  return (
    <Box style={styles.container}>
      <Skeleton height="$48" borderTopRadius="xl" />
      <Skeleton.Text lines={3} />

      <Box style={styles.footer}>
        <Skeleton rounded="full" h="$8" w="$24" />
        <Skeleton rounded="full" h="$4" w="$16" />
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: { gap: spacing.$4, margin: spacing.$4 },
  footer: { alignItems: 'flex-end', flexDirection: 'row', justifyContent: 'space-between' },
});
